import React from 'react';
import { FiMapPin, FiUsers, FiSun, FiCoffee, FiMap, FiHome } from 'react-icons/fi';
import { useInView } from 'react-intersection-observer';

const AnimatedSection = ({ children, className = '' }) => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });
  return <div ref={ref} className={`${className} ${inView ? 'slide-up' : ''}`} style={{ opacity: inView ? undefined : 0 }}>{children}</div>;
};

const ProfilPage = () => {
  const kecamatanData = [
    { nama: 'Aimere', penduduk: 15670, luas: '127.4 km²' },
    { nama: 'Bajawa', penduduk: 38215, luas: '48.5 km²' },
    { nama: 'Bajawa Utara', penduduk: 13890, luas: '78.2 km²' },
    { nama: 'Golewa', penduduk: 14320, luas: '98.6 km²' },
    { nama: 'Golewa Barat', penduduk: 12450, luas: '112.3 km²' },
    { nama: 'Golewa Selatan', penduduk: 11230, luas: '95.1 km²' },
    { nama: 'Inerie', penduduk: 9450, luas: '104.8 km²' },
    { nama: 'Jerebuu', penduduk: 8760, luas: '118.5 km²' },
    { nama: 'Riung', penduduk: 12540, luas: '215.6 km²' },
    { nama: 'Riung Barat', penduduk: 7820, luas: '186.3 km²' },
    { nama: 'Soa', penduduk: 8340, luas: '132.7 km²' },
    { nama: 'Wolomeze', penduduk: 5664, luas: '145.2 km²' },
  ];

  return (
    <div>
      {/* Hero */}
      <div className="profil-hero">
        <div className="container">
          <AnimatedSection>
            <div style={{ maxWidth: 700, margin: '0 auto' }}>
              <div style={{ fontSize: '0.8rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 2, color: 'var(--primary-300)', marginBottom: '0.75rem' }}>Profil Daerah</div>
              <h1 style={{ color: 'white', marginBottom: '1rem' }}>Kabupaten Ngada</h1>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.1rem', lineHeight: 1.7 }}>
                Kabupaten Ngada terletak di Pulau Flores, Provinsi Nusa Tenggara Timur. Dikenal dengan keindahan alam Gunung Inerie, kekayaan budaya adat Bajawa, dan kopi arabika berkelas dunia.
              </p>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Quick Stats */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container-wide">
          <div className="stats-grid">
            {[
              { icon: <FiMap />, value: '1.621 km²', label: 'Luas Wilayah', bg: 'var(--primary-100)', color: 'var(--primary-600)' },
              { icon: <FiUsers />, value: '158.349', label: 'Penduduk (2024)', bg: '#dbeafe', color: '#1d4ed8' },
              { icon: <FiHome />, value: '12', label: 'Kecamatan', bg: 'var(--gold-100)', color: 'var(--gold-600)' },
              { icon: <FiMapPin />, value: 'Bajawa', label: 'Ibukota', bg: 'var(--accent-100)', color: 'var(--accent-600)' },
              { icon: <FiSun />, value: '2.245 mdpl', label: 'Gunung Inerie', bg: '#dcfce7', color: '#15803d' },
              { icon: <FiCoffee />, value: '3.850 Ton', label: 'Produksi Kopi 2024', bg: '#fef3c7', color: '#a16207' },
            ].map((s, i) => (
              <AnimatedSection key={i}>
                <div className="stat-card" style={{ animationDelay: `${i * 0.1}s` }}>
                  <div className="stat-icon" style={{ background: s.bg, color: s.color }}>{s.icon}</div>
                  <div>
                    <div className="stat-value" style={{ fontSize: '1.5rem' }}>{s.value}</div>
                    <div className="stat-label">{s.label}</div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Visi Misi */}
      <section className="section">
        <div className="container">
          <AnimatedSection>
            <div className="section-header">
              <div className="overline">Visi & Misi</div>
              <h2>Membangun Ngada Bermartabat</h2>
            </div>
          </AnimatedSection>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
            <AnimatedSection>
              <div className="card" style={{ padding: '2rem' }}>
                <h3 style={{ color: 'var(--primary-700)', marginBottom: '1rem', fontSize: '1.3rem' }}>Visi</h3>
                <p style={{ fontSize: '1.05rem', lineHeight: 1.8, color: 'var(--gray-600)' }}>
                  Terwujudnya masyarakat Kabupaten Ngada yang bermartabat, sejahtera, dan berdaya saing berbasis kearifan lokal.
                </p>
              </div>
            </AnimatedSection>
            <AnimatedSection>
              <div className="card" style={{ padding: '2rem' }}>
                <h3 style={{ color: 'var(--primary-700)', marginBottom: '1rem', fontSize: '1.3rem' }}>Misi</h3>
                <div style={{ fontSize: '0.95rem', lineHeight: 1.8, color: 'var(--gray-600)', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                  <p>1. Meningkatkan kualitas SDM melalui pendidikan dan kesehatan</p>
                  <p>2. Mengembangkan ekonomi kerakyatan berbasis potensi lokal</p>
                  <p>3. Membangun infrastruktur yang merata dan berkelanjutan</p>
                  <p>4. Melestarikan budaya dan kearifan lokal</p>
                  <p>5. Mewujudkan tata kelola pemerintahan yang baik dan bersih</p>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Kecamatan */}
      <section className="section" style={{ background: 'white' }}>
        <div className="container-wide">
          <AnimatedSection>
            <div className="section-header">
              <div className="overline">Wilayah Administratif</div>
              <h2>12 Kecamatan</h2>
              <p>Data kependudukan dan luas wilayah per kecamatan</p>
            </div>
          </AnimatedSection>
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr><th>No</th><th>Kecamatan</th><th>Jumlah Penduduk</th><th>Luas Wilayah</th></tr>
              </thead>
              <tbody>
                {kecamatanData.map((kec, i) => (
                  <tr key={kec.nama}>
                    <td>{i + 1}</td>
                    <td><strong>{kec.nama}</strong></td>
                    <td>{kec.penduduk.toLocaleString('id-ID')} jiwa</td>
                    <td>{kec.luas}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Potensi */}
      <section className="section section-dark">
        <div className="container">
          <AnimatedSection>
            <div className="section-header">
              <div className="overline" style={{ color: 'var(--primary-300)' }}>Potensi Unggulan</div>
              <h2>Kebanggaan Ngada</h2>
            </div>
          </AnimatedSection>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
            {[
              { title: 'Kopi Arabika Bajawa', desc: 'Kopi specialty grade 84+ yang terkenal di pasar internasional, ditanam di lereng Gunung Inerie.' },
              { title: 'Gunung Inerie', desc: 'Gunung berapi setinggi 2.245 mdpl yang menjadi ikon dan daya tarik wisata utama Kabupaten Ngada.' },
              { title: 'Kampung Adat Bena', desc: 'Desa megalitikum yang masih lestari, menjadi destinasi wisata budaya bertaraf internasional.' },
              { title: 'Taman Laut 17 Pulau Riung', desc: 'Kawasan konservasi laut dengan 17 pulau kecil dan keanekaragaman hayati yang luar biasa.' },
              { title: 'Tenun Ikat Ngada', desc: 'Kain tenun tradisional dengan motif khas yang menjadi warisan budaya tak benda.' },
              { title: 'Festival Reba', desc: 'Upacara adat tahunan terbesar masyarakat Bajawa sebagai ungkapan syukur dan kebersamaan.' },
            ].map((p, i) => (
              <AnimatedSection key={i}>
                <div style={{ padding: '1.5rem', borderRadius: 16, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}>
                  <h4 style={{ color: 'var(--gold-400)', fontFamily: 'var(--font-body)', marginBottom: '0.5rem' }}>{p.title}</h4>
                  <p style={{ fontSize: '0.9rem', lineHeight: 1.6, color: 'var(--gray-400)' }}>{p.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProfilPage;
